<div class="confirm-payment-page" role="main" aria-label="Confirm payment page" *ngIf="appModel; else noPaymentData">
    <div class="confirm-header">
        <h2 [appTranslate]="'CONTINUE_PAYMENT'"></h2>
        <p>{{appModel.PermitTypeName}}, {{appModel.ParkingTypeName}}, {{appModel.PermitName}}</p>
    </div>

    <div class="confirm-payment-card">
        <div class="summary-row">
            <span [appTranslate]="'LICENSE_TYPE'"></span>
            <b>{{appModel.PermitTypeName}}</b>
        </div>
        <div class="summary-row">
            <span [appTranslate]="'PARKING_TYPE'"></span>
            <b>{{appModel.ParkingTypeName}}</b>
        </div>
        <div class="summary-row">
            <span [appTranslate]="'ZONE'"></span>
            <b>{{appModel.PermitName}}</b>
        </div>
        <div class="summary-row" *ngIf="appModel.Vehicles?.length">
            <span [appTranslate]="'VEHICLE'"></span>
            <b>{{appModel.Vehicles.length}}</b>
        </div>
        <div class="summary-row" *ngIf="appModel.Months">
            <span [appTranslate]="'MOUTHS_TO_PAY'"></span>
            <b>{{appModel.Months}}</b>
        </div>

        <div class="total-row">
            <span [appTranslate]="'TOTAL_SUM'"></span>
            <div class="total-amount">
                <strong>{{appModel.Price}}</strong>
                <b [appTranslate]="'DENARS'"></b>
            </div>
        </div>

        <div class="profile-actions jusitfy-content-between">
            <button type="button" class="btn btn-next" (click)="goToDashboard()">
                <span [appTranslate]="'CANCEL'"></span>
            </button>
            <button type="button" class="btn btn-primary" (click)="pay()">
                <span [appTranslate]="'TO_PAYMENT'"></span>
            </button>
        </div>

        <div class="errors" *ngIf="hasErrors">
            <span class="error">{{errorsMessages}}</span>
        </div>
    </div>
</div>

<ng-template #noPaymentData>
    <div class="confirm-payment-page empty-state">
        <div class="confirm-payment-card">
            <p [appTranslate]="'NO_DATA'">No payment data available.</p>
            <div class="profile-actions">
                <button type="button" class="btn btn-next" (click)="goToDashboard()">
                    <span [appTranslate]="'CANCEL'"></span>
                </button>
            </div>
        </div>
    </div>
</ng-template>

<div class="loader" *ngIf="myLoaderService.isLoading | async"></div>